import React from "react";
import { Navigate } from "react-router-dom";

// This component now handles its own logic, making it truly reusable.
const ProtectedRoute = ({ children }) => {
  // 1. The authentication logic is now INSIDE the component.
  const isAuthenticated = !!localStorage.getItem("token");

  // 2. The check is performed here.
  if (!isAuthenticated) {
    // 3. If not authenticated, redirect to the login page.
    // The 'replace' prop prevents the user from clicking "back" to a protected page after being redirected.
    return <Navigate to="/" replace />;
  }

  // 4. If authenticated, render the page component that was passed as children.
  return children;
};

export default ProtectedRoute;